import React, { useState } from "react";
import {
  CCard,
  CCardBody,
  CFormSelect,
  CButton,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CRow,
  CCol,
  CCardTitle,
} from "@coreui/react";
import { FaEye, FaFilter } from "react-icons/fa";
import userApi from "src/utils/axios";
import EnrolledStudents from "../Certificate/Enrolled_Students"; // import child component
import ConfigData from "../../../config/constant.json";

const GenerateCertificate = () => {
  const [filters, setFilters] = useState({
   
    course: "",
    batch: "",
   
  });

  const [showCourses, setShowCourses] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [view, setView] = useState(false);
  const [courseData, setCourseData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [courseName, setCourseName] = useState("");
  const [batchName, setBatchName] = useState("");
  const [courseBatchData, setCourseBatchData] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [batchData, setBatchData] = useState([]);
  

  React.useEffect(async () => {
    await getAllCourses();
    
  }, []);

  // Function to fetch all courses
  const getAllCourses = async () => {
    try {
      const response = await userApi.get(
        `${ConfigData.SERVER_URL}/admin/course/getcourses`
      );
      if (response.data.data) {
        setCourseData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

     const fetchCourseData = async (courseId) => {
          try {
              setSelectedCourse(courseId);
              setBatchData([]);
              const response = await userApi.get(`${ConfigData.SERVER_URL}/admin/batch/getBatchByCourseId?courseId=${courseId}`);
              if (response.data.data) {
                  setBatchData(response.data.data);
              }
          } catch (error) {
              console.log(error);
          }
      };


      const getCourseBatchData = async () => {
        
        try {
          const response = await userApi.get(
            `${ConfigData.SERVER_URL}/admin/course/getCourseBatchData?batchId=${selectedBatchId}&courseId=${selectedCourseId}`);
          
          if (response.data.data) {
            setCourseBatchData(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching courses:", error);
        }
      };


      const getEnrolledStudents = async (courseId, batchId) => {
        try {
          const response = await userApi.get(
            `${ConfigData.SERVER_URL}/admin/course/getEnrolledStudents?batchId=${batchId}&courseId=${courseId}`
          );
          
          if (response.data.data) {
            setStudentData(response.data.data); // Set the student data here
          }
        } catch (error) {
          console.error("Error fetching enrolled students:", error);
        }
      };
      
  const handleCourseChange = (e) => {
    
    const selectedValue = e.target.value;
    if (selectedValue) {
      const parsed = JSON.parse(selectedValue);
      
      setSelectedCourseId(parsed.id);
      setCourseName(parsed.name)
      fetchCourseData(parsed.id)
      
    } else {
      setSelectedCourseId("");
      setCourseName("");
    }
  };


  const handleBatchChange = (e) => {
    
    const selectedValue = e.target.value;
    if (selectedValue) {
      const parsed = JSON.parse(selectedValue);
      setSelectedBatchId(parsed.id);
      setBatchName(parsed.name)
      
    } else {
      setSelectedBatchId("");
      setBatchName("")
    }
  };
  const handleFilter = () => {
    getCourseBatchData()
   

  };

  // On clicking View, fetch enrolled students from API
  const handleViewEnrolledStudents = (courseId, batchId) => {
    getEnrolledStudents(courseId, batchId);
    setView(true);
  };
  

  const handleBack = () => {
    setView(false);
    setSelectedCourse(null);
  };

  return (
    <>
      {!view && (
        <>
          <div>
            <CRow>
              <CCol sm={12} className="pb-4">
                <CCard style={{ background: "#fff" }}>
                  <CCardBody>
                    <CRow>
                      <CCol sm={6}>
                        <CCardTitle style={{ color: "#000" }}>
                          Generate Certificate
                        </CCardTitle>
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
            <CCard className="mb-4">
              <CCardBody>
                {/* Dropdown filters (top row) */}
                <div className="row g-3 mb-3">
                  <div className="col-md-6">
                    <CFormSelect
                      aria-label="Select Course"
                      onChange={handleCourseChange}
                    >
                      <option value="">Select Course</option>
                      {courseData &&
                        courseData.map((course, index) => (
                          <option
                            key={index}
                            value={JSON.stringify({
                              name: course.courseName,
                              id: course._id,
                            })}
                          >
                            {course.courseName}
                          </option>
                        ))}
                    </CFormSelect>
                  </div>
                  <div className="col-md-6">
                    <CFormSelect
                      aria-label="Select Batch"
                      onChange={handleBatchChange}
                    >
                      <option value="">Select Batch</option>
                      {batchData.map((batch, index) => (
                        <option key={index} 
                        value={JSON.stringify({
                          name: batch.batchName,
                          id: batch._id,
                        })}
                        >{batch.batchName}</option>
                           ))}
                    </CFormSelect>
                  </div>
              
                </div>

                {/* Search + Filter button (below inputs) */}
                <div className="row mb-3">
                  {/* <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search courses..."
                    />
                  </div> */}
                  <div className="col-md-3"></div>
                  <div className="col-md-3 text-end">
                    <CButton
                      onClick={handleFilter}
                      style={{
                        color: "black",
                        backgroundColor: "rgb(214, 178, 49)",
                      }}
                    >
                      <FaFilter className="me-2" />
                      Filter
                    </CButton>
                  </div>
                </div>
              </CCardBody>
            </CCard>

            {/* Course Table */}
            {courseBatchData && (
  <CCard className="mb-3">
    <CCardBody>
      <h5 className="mb-3">Course Details</h5>

      <p><strong>Course Name:</strong> {courseBatchData.courseId?.courseName}</p>
      <p><strong>Batch Name:</strong> {courseBatchData?.batchName}</p>

      <button
        onClick={() =>
          handleViewEnrolledStudents(courseBatchData.courseId?._id, courseBatchData?._id)
        }
        className="btn btn-sm"
        style={{
          color: "black",
          backgroundColor: "rgb(214, 178, 49)",
        }}
      >
        <FaEye className="me-1" /> View Enrolled Students
      </button>
    </CCardBody>
  </CCard>
)}

          </div>
        </>
      )}

{view &&  studentData &&
  <EnrolledStudents
  studentData={studentData}
  onBack={handleBack}
  courseName={courseName}
  batchName={batchName}
  // batchId={batchId}
/>
}

    </>
  );
};

export default GenerateCertificate;
